import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";

/**
 * Marca el estado de pago de una factura de liquidación reutilizando Invoice.status
 * (1 = No pagada, 2 = Pagada, 3 = Rechazada). Al terminar, refresca el listado.
 */
function useMarkInvoicePaidAction(refresh?: any): any {
  const errorHandler = useErrorHandler();

  const markPaid = (invoiceId: number, status: number = 2) => {
    // eslint-disable-next-line no-alert
    if (!window.confirm("¿Marcar esta liquidación como pagada?")) {
      return;
    }
    store(`balances/invoice/${invoiceId}/status`, { status })
      .then(() => {
        if (refresh) refresh();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };

  return { markPaid };
}

export default useMarkInvoicePaidAction;
